import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import SearchBox from '@/components/SearchBox';

export default function searchComponentPriv(WrappedComponent, { modelKey, dealerEventCode }) {
  @connect((state) => ({
    currCustomer: state[modelKey].searchCustInfo,
    isCreate: state[modelKey].isCreate, // 只有新开页面能创建
    certTypeList: state.search.certTypeList,
    customerList: state.search.customerList,
    serviceTypeList: state.search.serviceTypeListObj[dealerEventCode] || [],
  }))
  class CheckComponentPriv extends React.Component {
    render() {
      const { currCustomer, isCreate } = this.props;
      // 用户是否存在, todo业务判断
      const exist = !isEmpty(currCustomer);
      return (
        <React.Fragment>
          {
            exist || isCreate ?
              <WrappedComponent /> :
              <SearchBox {...this.props} modelKey={modelKey} dealerEventCode={dealerEventCode} />
          }
        </React.Fragment>
      );
    }
  }
  return CheckComponentPriv;
}
